export interface ExpensePolicyLockingExpenseClass {
    AccountExpensePolicyId: string
    AccountId: number
    LockAllPreviousExpenseEntries: boolean
    LockAllPreviousMonthsExpenseEntries: boolean
}

export const expensePolicyLockingExpenseInitialsInitialsForAdd = {
    AccountExpensePolicyId: "",
    LockAllPreviousExpenseEntries: false,
    LockAllPreviousMonthsExpenseEntries: false
}

export const expensePolicyLockingExpenseInitialsForUpdate = {
    AccountExpensePolicyCategoryId: "",
    AccountExpensePolicyId: "",
    LockAllPreviousExpenseEntries: false,
    LockAllPreviousMonthsExpenseEntries: false
}